import { PageQuery } from '@/network/interfaces/PageQuery'
import { tech_group_detail } from '@/interfaces/tech_group_detail'
import { tech_info } from '@/interfaces/tech_info'
import { BaseRequest } from '@/network/requests/BaseRequest'
import { tech_group } from '@/interfaces/tech_group'
import { queryTechByIdList } from '@/network/requests/techInfo'
import { like } from '@/network/util/QueryBuilder'

export const techGroupRequest = BaseRequest.build<tech_group>('tech_group')

/**
 *
 */
export const techGroupDetailRequest = BaseRequest.build<tech_group_detail>('tech_group_detail')

/**
 *
 * @param page
 * @param pagesize
 * @param nameSearch
 */
export function queryTechGroups(page: number, pagesize: number, nameSearch = '') {
	const query: PageQuery = {
		page,
		pagesize,
	}
	if (nameSearch) {
		query.filter = {
			name: like(nameSearch),
		}
	}
	return techGroupRequest.queryPage(query)
}

/**
 * 查询工艺参数组所包含的工艺参数
 * @param techGroupId
 */
export async function queryTechGroupDetailById(techGroupId: string): Promise<tech_info[]> {
	if (!techGroupId) {
		return []
	}
	const techGroupDetailList = await techGroupDetailRequest.queryAll({
		tech_group_id: techGroupId,
	})
	const techIds: string[] = techGroupDetailList.map(detail => detail.tech_id || '').filter(id => id !== '')
	return queryTechByIdList(techIds)
}
